<template>
	<div class="login-container">
		<div class="loginTop">
			<el-image style="height: 55px" :src="url" fit="contain"></el-image>
			<Lang />
		</div>

		<el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form"
			@keyup.enter.native="handleLogin">
			<div class="title-container">
				<h3 class="title">{{ $t('欢迎回来') }}</h3>
				<!-- <p class="sub-title">
					{{ $t('没有账号') }}？
					<router-link to="/register" class="link-text">
						{{ $t('立即注册') }}
					</router-link>
				</p> -->
			</div>
			<el-form-item prop="username">
				<el-input v-model="loginForm.username" :placeholder="$t('请输入账号')" type="text"
					prefix-icon="el-icon-user" />
			</el-form-item>
			<el-form-item prop="password">
				<el-input v-model="loginForm.password" :placeholder="$t('请输入密码')" show-password
					prefix-icon="el-icon-lock" />
			</el-form-item>

			<div class="aux-handler">
				<el-checkbox v-model="loginForm.remember">{{ $t('保持登录状态') }}</el-checkbox>
				<!-- <router-link to="/forgetPwd" class="forget-pwd">
					{{ $t('忘记密码') }}？
				</router-link> -->
			</div>

			<el-button type="primary" class="login-btn" @click="handleLogin" :loading="loading">
				{{ $t('登录') }}
			</el-button>
		</el-form>
	</div>
</template>

<script>
	import Lang from '../../common/Lang.vue';

	export default {
		components: {
			Lang
		},
		data() {
			return {
				loading: false,
				url: require('../../assets/image/1.png'),
				loginForm: {
					username: localStorage.getItem('username') || '',
					password: localStorage.getItem('password') || '',
					remember: true
				},

			}
		},
		computed: {
			loginRules() {
				return {
					username: [{
						required: true,
						trigger: 'blur',
						message: this.$t('请输入账号')
					}],
					password: [{
						required: true,
						trigger: 'blur',
						message: this.$t('请输入密码')
					}]
				};
			}
		},
		methods: {
			handleLogin() {
				if (this.loginForm.remember) {
					localStorage.setItem('username', this.loginForm.username)
					localStorage.setItem('password', this.loginForm.password)
				} else {
					localStorage.removeItem('username');
					localStorage.removeItem('password');
				}

				this.$axios.post(this.$apis.login, {
					account: this.loginForm.username,
					password: this.loginForm.password,
				}).then(res => {
					if (res.code == 1) {
						console.log(res.data);
						this.$store.commit('setUserInfo', res.data.info)
						this.$store.commit('setToken', res.data.info.token)
						this.$message.success(res.msg)
						// 延时跳转，让用户看到提示
						setTimeout(() => {
							this.$nav.go('/home/home');
						}, 800)
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	$primary_blue: #3e52ff;
	$text_color: #333;
	$sub_text: #909399;

	.login-container {
		min-height: 100vh;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%); // 增加渐变底色
		position: relative;

		.loginTop {
			width: 100%;
			position: absolute;
			top: 0;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 20px 40px;
			box-sizing: border-box;
		}

		.login-form {
			width: 460px;
			background-color: #fff;
			padding: 40px;
			border-radius: 16px;
			box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05); // 增加阴影让表单更立体

			.title-container {
				text-align: center;
				margin-bottom: 30px;

				.title {
					font-size: 28px;
					color: $text_color;
					font-weight: 600;
					margin: 0;
				}

				.sub-title {
					font-size: 14px;
					color: $sub_text;
					margin-top: 12px;

					.link-text {
						text-decoration: none;
						color: $primary_blue;
						font-weight: 500;

						&:hover {
							text-decoration: underline;
						}
					}
				}
			}

			::v-deep .el-form-item {
				margin-bottom: 25px;
			}

			::v-deep .el-input__inner {
				height: 50px;
				border-radius: 8px;
				border: 1px solid #dee0e3;
				transition: all 0.3s;

				&:focus {
					border-color: $primary_blue;
					box-shadow: 0 0 0 3px rgba($primary_blue, 0.1);
				}
			}

			.aux-handler {
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin: 20px 0 30px;
				font-size: 14px;

				.forget-pwd {
					text-decoration: none;
					color: $sub_text;

					&:hover {
						color: $primary_blue;
					}
				}
			}

			.login-btn {
				width: 100%;
				height: 50px;
				font-size: 16px;
				font-weight: 600;
				background-color: $primary_blue;
				border: none;
				border-radius: 25px;
				box-shadow: 0 4px 12px rgba($primary_blue, 0.3);

				&:hover {
					background-color: lighten($primary_blue, 5%);
					transform: translateY(-1px);
				}

				&:active {
					transform: translateY(0);
				}
			}
		}
	}
</style>